import { createAction } from "@reduxjs/toolkit";
import { River } from "src/types/river";


export const RIVERS_GET_ALL = createAction<{ rivers: River[] }>("@rivers/GET_ALL");
export const RIVERS_GET_BY_ID = createAction<{ river: River }>("@rivers/GET_BY_ID");
export const RIVERS_ADD = createAction<{ river: River }>("@rivers/ADD");
export const RIVERS_UPDATE = createAction<{ river: River }>("@rivers/UPDATE");
export const RIVERS_DELETE = createAction<{ riverId: string }>("@rivers/DELETE");
